import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const CompanySettingsPage = lazy(() =>
  import('@/features/settings/company/CompanySettingsPage').then((m) => ({ default: m.CompanySettingsPage })),
);

export const Route = createFileRoute('/app/settings/company')({
  component: () => (
    <Suspense>
      <CompanySettingsPage />
    </Suspense>
  ),
});
